import { TransactionAdjustmentComponent } from "../../components";

export default function TransactionAdjustmentDataPage() {
  return <TransactionAdjustmentComponent.TransactionAdjustmentDataList />;
}
